/* eslint-disable */

export const DRAWER_CONSTANTS = {
    OPEN_MENU: 'OPEN_MENU',
    OPEN_SEARCH: 'OPEN_SEARCH',
    CLOSE: 'CLOSE',
};
